import React from 'react';
import { Switch, Space } from 'antd';

export default function RegistrationSettings({ registrationEnabled, loading, onChange }) {
    return (
        <Space>
            <Switch checked={!!registrationEnabled} loading={loading} onChange={onChange} />
            <span>Allow new user registration</span>
        </Space>
    );
}
